import React from 'react'
import { makeStyles, Grid, Typography, Chip, Link } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#211A29',
    padding: '80px 20px',
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      padding: '80px 120px',
    },
  },
  header: {
    color: 'white',
    margin: '1rem 0',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '52px',
    },
  },
  chip: {
    background: 'rgba(11, 11, 11, 0.8)',
    color: 'white',
  },
  link: {
    color: 'white',
    fontSize: '.8rem',
    padding: '.4rem 0',
    borderBottom: '1px solid white',
  },
  contentSection: {
    margin: '1rem 0',
    '& p': {
      color: 'white',
    },
  },
  contentCard: {
    padding: '1rem',
    background: 'rgba(255, 255, 255, 0.06)',
    borderRadius: '.4rem',
  },
  cardBody: {
    fontSize: '1rem',
  },
  cardHeader: {
    margin: '0 0 1rem 0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
}))

export default function EarnGuide(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Chip label="Earn guide" className={classes.chip} />
      <Typography variant="h1" className={classes.header}>
        How to choose the right Crypto Lending platform
      </Typography>
      {/* <Link className={classes.link} underline="none">
        See the whole guide
      </Link> */}
      <div>
        <Grid container className={classes.contentSection} spacing={2} wrap="wrap">
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Security
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                Whether it’s a centralized saving provider or DeFi - you want to use a platform that
                is secure. Time is the best proof-of-security. Check how long a platform has been
                running without major hiccups.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Ease of use
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                A good and user-friendly interface goes a long way to make a platform enjoyable to
                use. The whole process should be straightforward and if there are questions left
                customer support should be in reach.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Value Locked
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                Total value locked is a metric that is commonly used to assess popularity of a
                lending platform. It refers to how much funds have been deposited by users. It
                demonstrates confidence in the platform and popularity.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Fees
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                DeFi protocols typically take significantly less fees than centralized saving apps
                as they exist to cut out the middlemen. When you lend funds on a DeFi platform you
                are matched to a borrower through a smart contract - no operational costs.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
